export default function ContactIcon(){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><path d="M24,11.309V24H12.018A12,12,0,1,1,24,11.246ZM13,7H7V9h6Zm4,4H7v2H17Zm0,4H7v2H17Z"/></svg>
    );
}